import {defineStore} from 'pinia'
import {http} from '@/extensions/http/index.js'
import {API_ENDPOINTS} from '@/config/index.js'

export const useDocumentStore = defineStore('document', {
    state: () => {
        return {
            all: null
        }
    },
    actions: {
        async init() {
            try {
                if (this.all) return

                const {data} = await http.get(API_ENDPOINTS.DOCUMENT.INDEX)

                this.all = data
            } catch { /**/ }
        },
        async uploadFile(id, file) {
            try {
                const formData = new FormData()
                formData.append('file', file)

                const {data} = await http.post(API_ENDPOINTS.DOCUMENT.UPLOAD_FILE.replace(':id', id), formData)

                this.all = this.all.map(document => {
                    if (document.id.toString() === id.toString()) {
                        document.file = data.data
                    }

                    return document
                })
            } catch { /**/ }
        },
        async destroy(id) {
            try {
                await http.delete(API_ENDPOINTS.DOCUMENT.DESTROY.replace(':id', id))

                this.all = this.all.filter(document => document.id.toString() !== id.toString())
            } catch { /**/ }
        },
        async store(payload) {
            try {
                const {data} = await http.post(API_ENDPOINTS.DOCUMENT.STORE, payload)

                this.all.push(data)

                return data.id
            } catch { /**/ }
        },
        async update(id, payload) {
            try {
                const {data} = await http.put(API_ENDPOINTS.DOCUMENT.UPDATE.replace(':id', id), payload)

                this.all = this.all.map(document => {
                    if (document.id.toString() === id.toString()) {
                        document = data
                    }

                    return document
                })
                return data.id
            } catch { /**/ }
        }
    }
})